import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { api } from "../lib/api";
import { Link, useNavigate } from "react-router-dom";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
    const { user, authLoading } = useApp();
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (authLoading) return;
        if (!user) { navigate("/login"); return; }
        api.get("/wishlist").then(r => setItems(r.data)).finally(() => setLoading(false));
    }, [user, authLoading, navigate]);

    if (authLoading || !user || loading) return <div className="px-6 py-20 text-[color:var(--ms-muted)] text-sm">Caricamento…</div>;

    return (
        <div className="px-6 md:px-12 lg:px-24 py-16" data-testid="wishlist-page">
            <div className="overline mb-3">Salvati</div>
            <h1 className="font-display text-5xl tracking-tight text-[color:var(--ms-charcoal)] mb-10">I tuoi preferiti</h1>
            {items.length === 0 ? (
                <div className="panel p-16 text-center text-[color:var(--ms-muted)]" data-testid="wishlist-empty">
                    Nessun capo salvato. <Link to="/shop" className="text-[color:var(--ms-sage-dark)] link-underline">Scopri la collezione</Link>
                </div>
            ) : (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-10">
                    {items.map(p => <ProductCard key={p.id} product={p} />)}
                </div>
            )}
        </div>
    );
}
